//
//
//
//
//
//
//
//
//

import { getXAccountUrl2 } from "@js/public/mUtils";
export default {
    name: "train",
    data() {
        return {
            ifHeight: '520px',
            srcUrl: ''
        }
    },
    created() {
        this.srcUrl = getXAccountUrl2("", '0');
        console.log(this.srcUrl);
        window.location.href = this.srcUrl
    },
    mounted() {
         const oIframe = document.getElementById('bdIframe');
            const deviceWidth = document.documentElement.clientWidth;
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.width = (Number(deviceWidth)) + 'px'; //数字是页面布局宽度差值
            oIframe.style.height = (Number(deviceHeight)-55) + 'px'; //数字是页面布局高度差

        this.eventBus.$emit("changeMenu", 2);
    },
    activated() {
        this.changeTableMaxHeight()
        this.eventBus.$emit("changeMenu", 2);
    },
    methods: {
        changeTableMaxHeight() {
            let height = document.body.clientHeight // 网页可视区域高度
            console.log(height, 99928777);
        }
    },
    
}



// WEBPACK FOOTER //
// ./src/components/personalCenter/train.vue